{
  "INDIVIDUAL": "Individu",
  "PUBLICLY_LISTED_ENTITY": "Entité cotée en bourse",
  "PRIVATE_COMPANY": "Entreprise privée",
  "PARTNERSHIP": "Partenariat",
  "SOLE_PROPRIETORSHIP": "Entreprise individuelle",
  "TRUST": "Fiducies",
  "INVESTMENT_FUND": "Banquier d’investissement",
  "REGULATED_ENTITY": "Entité réglementée",
  "OTHER": "Autre",
  "NON_INDIVIDUAL": "Non-individuel"
}
